export default "__VITE_ASSET__5U9bH9K6__"